module.exports = __webpack_public_path__ + "img/other_parrot.4cbbe5f5.jpg";